/**
 * Created by claudio iozzia on 14/06/2017.
 */
import {siPrefix} from "./siPrefix";

export interface IScaledNumber {
  readonly value: number;
  readonly prefix: siPrefix;

  readonly unitValue: number; // { return value * prefix.value; }
  toUnit(): IScaledNumber; // { return new IScaledNumber(unitValue, siPrefix.unit); }
}

export class ScaledNumber implements IScaledNumber {
  public static zero: IScaledNumber = new ScaledNumber(0, siPrefix.unit);
  public static nan: IScaledNumber = new ScaledNumber(NaN, siPrefix.unit);

  public constructor(private _value: number, private _prefix: siPrefix) {
  }

  public get value(): number {
    return this._value;
  }

  public get prefix(): siPrefix {
    return this._prefix;
  }

  public get unitValue(): number {
    return this.value * this.prefix.value;
  }

  public toUnit(): IScaledNumber {
    return new ScaledNumber(this.unitValue, siPrefix.unit);
  }

}
